import { z } from 'zod'
import { oc } from '@orpc/contract'
import { taskSchema } from './tasks-shared.contract'

export const getTask = oc
  .route({ method: 'GET', path: '/v2/tasks/{slug}' })
  .input(z.object({ slug: z.string().min(1) }))
  .output(z.object({ data: taskSchema }))
